import { QueryClientProvider } from '@tanstack/react-query';
import * as React from 'react';

import { trpc } from './client';
import { queryClient, trpcReactClient } from './shared';

export function TRPCProvider({ children }: { children: React.ReactNode }): React.ReactElement {
  return (
    <trpc.Provider client={trpcReactClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </trpc.Provider>
  );
}
